import { useCallback, useRef } from 'react';
import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';

import { Waypoint } from 'src/app/shared/components/scroll';

import type { TipCardConfig } from '../types';

export const TipCard: React.FC<{ tip: TipCardConfig }> = ({ tip }) => {
	const track = useTracking();
	const viewTracked = useRef(false);
	const trackView = useCallback(() => {
		if (viewTracked.current) return;
		void track('petition_strength_card_view', {
			card: tip.type,
		});
		viewTracked.current = true;
	}, [track, tip.type, viewTracked]);

	return (
		<div className="stroke-weaker bg-background-base elevation-low flex h-full w-80 flex-col gap-2 rounded-xl border p-5">
			<Text as="p" size="xx-small" variant="heading">
				<TypedTranslate value={tip.title} />
			</Text>
			<Text as="p" size="small" variant="body" className="text-typography-weak">
				<TypedTranslate value={tip.body} />
			</Text>
			<Link className="mt-auto" onClick={tip.onClick} size="small" bold data-qa="tip-card-primary-action">
				<TypedTranslate value={tip.primaryActionText} />
			</Link>
			<Waypoint horizontal onEnter={trackView} />
		</div>
	);
};
